<form [formGroup]="paymentForm" (ngSubmit)="submitForm()" class="tab-form" autocomplete="off" novalidate>
  <div class="form-80">
    <h1 class="blue margin">{{ title }}</h1>
    <p class="lead rocal">
      {{ subtitle }}
    </p>

    <div class="flex blue-box">
      <p class="blue lead">
        {{ paymentTitle }}
      </p>
      <div class="line-2"></div>

      <div class="flex row">
        <p class="lead rocal">Trust Creation Fee</p>
        <p><strong>KSH{{' ' +trustFee.toLocaleString('en-US')}}</strong></p>
      </div>
      <div class="line-2"></div>

      <p class="lead rocal">
        Select any additional services below (Optional)
      </p>
      <!-- CHECKBOXES -->
      <div class="flex column pay-bar grey-borders">
        <div class="flex fill grey-bottom">
          <mat-checkbox [formControl]="plusLegal" style="width: 100%;">
            <div class="flex row">
              <div class="flex fill">
                <p class="lead rocal">
                  Legal Review and Opinion of Asset Listing
                </p>
              </div>

              <p><strong>KSH{{' ' +legalReviewFee.toLocaleString('en-US')}}</strong></p>
            </div>
          </mat-checkbox>
        </div>

        <div class="flex fill grey-bottom">
          <mat-checkbox [formControl]="plusTax" style="width: 100%;">
            <div class="flex row">
              <div class="flex fill">
                <p class="lead rocal">
                  Tax Consultation
                </p>
              </div>

              <p><strong>KSH{{' ' +taxConsFee.toLocaleString('en-US')}}</strong></p>
            </div>
          </mat-checkbox>
        </div>

        <div class="flex fill">
          <mat-checkbox [formControl]="plusInvestment" style="width: 100%;">
            <div class="flex row">
              <div class="flex fill">
                <p class="lead rocal">
                  Investment Consultation
                </p>
              </div>

              <p><strong>KSH{{' ' +investmentConsFee.toLocaleString('en-US')}}</strong></p>
            </div>
          </mat-checkbox>
        </div>
      </div>
      <!-- TOTAL AMOUNT TO PAY -->
      <div class="flex fill row" style="align-items: center;">
        <div class="flex fill">
          <p class="lead">
            Gross Amount
          </p>
        </div>

        <p class="amount" style="color: black;"><strong>KSH{{' ' +totalAmount.toLocaleString('en-US')}}</strong></p>
      </div>
      <div class="line" style="margin: 0px;"></div>
      <!-- TOTAL AMOUNT TO PAY -->
      <div class="flex fill row" style="align-items: center;">
        <div class="flex fill">
          <p class="blue lead">
            Total Amount To Pay ( +{{ vatAmount }}% VAT )
          </p>
        </div>

        <p class="amount"><strong>KSH{{' ' +returnNetAmount().toLocaleString('en-US')}}</strong></p>
      </div>
      <div class="line" style="margin-top: 15px;"></div>
      <!-- MAKE PAYMENT -->
      <div *ngIf="!payment.done">
        <p class="blue lead">
          {{ title }}
        </p>
        <p>
          {{makePaymentOption}}
        </p>
        <!-- FULL / PARTIAL PAYMENT -->
        <div class="row" style="display: flex; align-items: center; justify-content: center; margin-top: 10px;">
          <app-radios style="display: flex; width: 100%; align-items: center; justify-content: center;"
            labelOptionA="Pay Full Amount" labelOptionB="Pay in Installments" [preSelect]="false"
            (valueChange)="onOptionChange($event)">
          </app-radios>
        </div>
        <p>
          *Receive a 10% discount for full payment
        </p>

        <div *ngIf="payFullAmount == false">
          <p class="blue lead">
            {{ instalmenPaymentsTitle }}
          </p>
          <p>
            {{instalmenPaymentOption}}
          </p>

          <div class="line-2"></div>
          <!-- INSTALLMENTS OPTION -->
          <div class="row" style="display: flex; align-items: center; justify-content: center; margin-top: 25px;">
            <app-radios style="display: flex; width: 100%; align-items: center; justify-content: center;"
              labelOptionA="50% upon submitting application then 50% within four (4) months"
              labelOptionB="30% upon submitting application then 70% within four (4) months" [preSelect]="false"
              (valueChange)="onInstalmentChange($event)">
            </app-radios>
          </div>
        </div>

        <div *ngIf="payFullAmount == true || payFullAmount == false && pay50Instalment !== null"
          style="margin-top: 20px;">
          <p class="blue lead">
            {{ trustDetailsTitle }}
          </p>
          <div class="line-2"></div>
          <div class="row half">
            <app-input [formGroup]="paymentForm" controlName="trustName" label={{trustLabel}} hint={{trustHint}}
              [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
          </div>

          <div class="row" style="margin-top: 10px;" [ngClass]="{'width-50' : !(
                            paymentForm.get('referree')?.value === 'Other' ||
                            paymentForm.get('referree')?.value === 'Independent Agent' ||
                            paymentForm.get('referree')?.value === 'Broker' ||
                            paymentForm.get('referree')?.value === 'ICEA LION Financial Advisor' ||
                            paymentForm.get('referree')?.value === 'ICEA LION Trust Consultant'
                        )}
                    ">
            <app-input [formGroup]="paymentForm" controlName="referree" label={{referreLabel}} hint={{selectText}}
              inputType="select" [ArrayItems]="HearAboutusData" [validationMessages]="validationMessages"
              [formErrors]="formErrors"></app-input>

            <app-input [formGroup]="paymentForm" controlName="other"
              *ngIf="paymentForm.get('referree')?.value === 'Other'" label={{referreeOtherLabel}}
              hint={{referreeOtherHint}} [validationMessages]="validationMessages"
              [formErrors]="formErrors"></app-input>

            <app-input [formGroup]="paymentForm" controlName="referreeName" *ngIf="paymentForm.get('referree')?.value === 'Independent Agent' ||
                                paymentForm.get('referree')?.value === 'Broker' ||
                                paymentForm.get('referree')?.value === 'ICEA LION Financial Advisor' ||
                                paymentForm.get('referree')?.value === 'ICEA LION Trust Consultant' " [label]="
                                paymentForm.get('referree')?.value === 'Broker' ? 'Name of Broker' :
                                paymentForm.get('referree')?.value === 'ICEA LION Trust Consultant' ? 'Name of Consultant' :
                                paymentForm.get('referree')?.value === 'ICEA LION Financial Advisor' ? 'Name of Financial Advisor'
                                : agentLabel" inputType="auto-complete" [ArrayItems]="IntermediaryOptions"
              [loadingOptions]="loadingIntermediaries" hint={{agentHint}} [validationMessages]="validationMessages"
              [formErrors]="formErrors">
            </app-input>
          </div>
        </div>
        <!-- PAYMENT INPUTS SECTION -->
        <div *ngIf="payFullAmount == true || payFullAmount == false && pay50Instalment !== null"
          style="margin-top: 20px;">
          <p class="blue lead">
            {{ paymentDetailsTitle }}
          </p>
          <div class="line-2"></div>

          <div class="row" *ngIf="payFullAmount == false && pay50Instalment !== null"
            [ngClass]="{'half': paymentForm.controls['PaymentMode'].value != PaymentModeOptions[1]}">
            <!-- Select Payment Mode -->
            <app-input [formGroup]="paymentForm" controlName="PaymentMode" label={{paymentModeLabel}} inputType="select"
              [ArrayItems]="PaymentModeOptions" [validationMessages]="validationMessages"
              [formErrors]="formErrors"></app-input>
            <app-input [formGroup]="paymentForm" controlName="receipt"
              *ngIf="paymentForm.controls['PaymentMode'].value === PaymentModeOptions[1]" label="M-PESA Receipt"
              hint={{receiptLabel}} subtext={{receiptHint}} required="false" [validationMessages]="validationMessages"
              [formErrors]="formErrors"></app-input>
          </div>

          <!-- PAYMENT DIRECT CARD -->
          <app-cards *ngIf="paymentForm.controls['PaymentMode'].value == PaymentModeOptions[3]"
            #cardsComponent
            returnURL="estate-planning/set-up"
            [formGroup]="paymentForm"
            [payer]="settlors[0]"
            [amount]="returnNetAmount()"
            (paymentSuccess)="onCardPaymentSuccess()"
          ></app-cards>

          <!-- FULL PAYMENT / PARTIAL BANK PAYMENT-->
          <div
            *ngIf="payFullAmount == true || (payFullAmount == false && pay50Instalment !== null && paymentForm.controls['PaymentMode'].value == PaymentModeOptions[2])">
            <div class="row">
              <app-input [formGroup]="paymentForm" inputType="view" label='Pay' subtext="{{amountHint}}"
                hint="{{ 'KSH ' +paymentAmount.toLocaleString()}}"></app-input>
              <app-input [formGroup]="paymentForm" controlName="bank"
                [selectFunction]="populateBankBranchesList.bind(this)" inputType="select" [ArrayItems]="BanksOptions"
                [loadingOptions]="loadingBanks" label={{bankLabel}} hint={{bankHint}}
                [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
            </div>

            <div class="row">
              <app-input [formGroup]="paymentForm" controlName="bankBranch" label={{bankBranchLabel}}
                hint={{bankBranchHint}} inputType="select" [ArrayItems]="BranchPlaceHolders"
                [loadingOptions]="loadingBankBranches" [validationMessages]="validationMessages"
                [formErrors]="formErrors"></app-input>
              <app-input [formGroup]="paymentForm" controlName="accName" label={{accNameLabel}} hint={{accNameHint}}
                [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
            </div>

            <div class="row">
              <app-input [formGroup]="paymentForm" controlName="acc" label={{accLabel}} hint={{accHint}}
                [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
              <app-input [formGroup]="paymentForm" controlName="slipDoc" [fileFunction]="updateSlipObject.bind(this)"
                label={{uploadSlipLabel}} inputType="file" [validationMessages]="validationMessages"
                [formErrors]="formErrors"></app-input>
            </div>
          </div>

          <!-- PARTIAL PAYMENT MPESA -->
          <div
            *ngIf="payFullAmount == false && pay50Instalment !== null && paymentForm.controls['PaymentMode'].value == PaymentModeOptions[0]">
            <div class="row">
              <app-input [formGroup]="paymentForm" controlName="phone" label={{phoneLabel}} inputType="phone"
                [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
              <app-input [formGroup]="paymentForm" inputType="view" label='Amount'
                hint="{{ 'KSH ' +paymentAmount.toLocaleString()}}"></app-input>
            </div>
          </div>

          <!-- BANK DETAILS -->
          <div
            *ngIf="payFullAmount == true || (payFullAmount == false && pay50Instalment !== null && paymentForm.controls['PaymentMode'].value == PaymentModeOptions[2])"
            class="bankBox-wrap">
            <div class="bankBox">
              <p class="lead blue" style="margin-bottom: -20px; margin-left: 0px; font-weight: 600;">
                {{instructionsTitleBank}}
              </p>
              <div class="line"></div>
              <div class="row">
                <div>{{iceaFundLabel}}</div>
                <div class="right-divs">{{iceaFundNameVal}}</div>
              </div>
              <div class="row">
                <div>{{iceaAcc}}</div>
                <div class="right-divs">{{iceaAccountVal}}</div>
              </div>
              <div class="row">
                <div>{{iceaBank}}</div>
                <div class="right-divs">{{iceaBankVal}}</div>
              </div>
              <div class="row">
                <div>{{iceaBranch}}</div>
                <div class="right-divs">{{iceaBranchVal}}</div>
              </div>
              <div class="row">
                <div>{{iceaBankCode}}</div>
                <div class="right-divs">{{iceaBankCodeVal}}</div>
              </div>
              <div class="row">
                <div>{{iceaBranchCode}}</div>
                <div class="right-divs">{{iceaBranchCodeVal}}</div>
              </div>
              <div class="row">
                <div>{{iceaClearing}}</div>
                <div class="right-divs">{{iceaClearingVal}}</div>
              </div>
            </div>
          </div>

          <!-- M-PESA EXPRESS DETAILS -->
          <div
            *ngIf="payFullAmount == false && pay50Instalment !== null && paymentForm.controls['PaymentMode'].value == PaymentModeOptions[0]"
            class="badge-wrapper">
            <div class="badge">
              <p class="lead blue" style="font-size: larger; margin-left: 2.8%; font-weight: 600;">
                {{instructionsTitle}}
              </p>
              <ol>
                <li>{{inst1}}</li>
                <li>Click on the <strong>"Submit"</strong> Button below.</li>
                <li>{{inst2}}</li>
                <li>{{inst2X}}</li>
                <li>{{inst3}}</li>
              </ol>

              <div style="height: 20px;"></div>
            </div>
          </div>

          <!-- M-PESA PAYBILL DETAILS -->
          <div
            *ngIf="payFullAmount == false && pay50Instalment !== null && paymentForm.controls['PaymentMode'].value == PaymentModeOptions[1]"
            class="badge-wrapper">
            <div class="badge">
              <p class="lead blue" style="font-size: larger; margin-left: 2.8%; font-weight: 600;">
                {{instructionsTitle2}}
              </p>
              <ol>
                <li>Ensure you have filled in the form above correctly (The <strong>Confirm Payment</strong> Button
                  should turn <strong>blue</strong>)</li>
                <li>{{inst4}}</li>
                <li>{{inst5}}<b>{{iceaPaybill}}</b></li>
                <li>{{inst6}}<b>{{ paymentID }}</b></li>
                <li>Set the amount as <strong>Ksh {{paymentAmount}}</strong></li>
                <li>{{inst8}}</li>
                <li>Please do <strong>NOT</strong> close this page <strong>UNTIL</strong> the Payment is confirmed</li>
                <li>If the payment isn't completed automatically, use the <strong>"Confirm Payment"</strong> Button to
                  Confirm the status</li>
              </ol>

              <div style="height: 20px;"></div>
            </div>
          </div>

          <!-- CARD DETAILS -->
          <div *ngIf="paymentForm.controls['PaymentMode'].value == PaymentModeOptions[3]" class="badge-wrapper">
            <div class="badge">
              <p class="lead blue" style="font-size: larger; margin-left: 2.8%; font-weight: 600;">
                {{'Card Payment Instructions'}}
              </p>
              <ol>
                <li>Ensure you have filled in the card details form above correctly (The <strong>Submit</strong> Button should turn <strong>blue</strong>)</li>
                <li>Please do <strong>NOT</strong> close this page <strong>UNTIL</strong> the Payment is confirmed</li>
              </ol>
              <div style="height: 20px;"></div>
            </div>
          </div>
        </div>
      </div>
      <!-- PAYMENT SUMMARY -->
      <div *ngIf="payment.done">
        <div class="badge-wrapper" style="margin-top: 0px;">
          <div class="badge">
            <p class="lead blue" style="font-size: larger; margin-left: 2.8%; font-weight: 600;">
              {{ 'Payment Summary' }}
            </p>
            <ul>
              <li>{{'Payment Mode : '}}&nbsp;&nbsp;<b>{{ payment.mode || 'MPESA' }}</b></li>
              <li *ngIf="payment.mode != 'RTGS' ">{{'Phone Number : '}}&nbsp;&nbsp;<b>{{ payment.phone || '0712333454'
                  }}</b></li>
              <li>Paid Amount&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;&nbsp;&nbsp;<b>KSH{{payment.Amount ? ' '
                  +payment.Amount.toLocaleString('en-US') : ' 10, 000 Tests' }}</b></li>

              <br *ngIf="payment.mode != 'RTGS' ">
              <li *ngIf="payment.mode != 'RTGS' ">    
                {{ paymentForm.controls['PaymentMode'].value == PaymentModeOptions[3] ? 'Reference' : 'MPESA Receipt : ' }}
                <b style="color: #003764;">{{ stkRequestID }}</b>
              </li>
            </ul>
            <div style="height: 20px;"></div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- BOTTOM OF FORM -->
  <app-form-bottom style="width: 100%;" [service]="estateControlService"
    [text]="payment.done ? (loading ? 'Saving Details': 'Next') : (loading ? 'Processing Payment': paymentForm.controls['PaymentMode'].value == PaymentModeOptions[1] ? 'Confirm Payment' : 'Submit') "
    [formValid]="payment.done || payment.uploaded ? true : paymentForm.valid ? true : false" [showContinue]="'false'"
    [buttonClickHandler]="submitForm.bind(this)">
  </app-form-bottom>
</form>